/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dropbox_Rollout_UnavailableInputs */

const en_dropbox_rollout_unavailable = /** @type {(inputs: Dropbox_Rollout_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sorry, Dropbox is temporarily unavailable while we finish rolling it out. You can still upload your files directly.`)
};

const es_dropbox_rollout_unavailable = /** @type {(inputs: Dropbox_Rollout_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lo sentimos, Dropbox no está disponible temporalmente mientras terminamos de lanzarlo. Puedes seguir subiendo tus archivos directamente.`)
};

/**
* | output |
* | --- |
* | "Sorry, Dropbox is temporarily unavailable while we finish rolling it out. You can still upload your files directly." |
*
* @param {Dropbox_Rollout_UnavailableInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dropbox_rollout_unavailable = /** @type {((inputs?: Dropbox_Rollout_UnavailableInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dropbox_Rollout_UnavailableInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dropbox_rollout_unavailable(inputs)
	return en_dropbox_rollout_unavailable(inputs)
});